import { Proxy } from '@skinsoft/network'
import { identity, of } from 'rxjs'
import { delay, map, retryWhen, scan, switchMap } from 'rxjs/operators'

function startExport(
    itemId: string,
    language: string,
    printableReportId: string,
    shouldBeRotated: boolean,
) {
    return new Proxy().fetch(`/export/printable-report`, undefined, 'POST', {
        indexSearchRequest: { page: 0, pageSize: 1 },
        language: language,
        searchMode: 'selectedResults',
        selectedIds: [itemId],
        printableReportId: printableReportId,
        pdfPagination: false,
        fileName: '',
        numberLabelPerObject: 1,
        shouldBeRotated
    })
}

function repeatedlyCheckExportStatus(exportId: string, maxRetry: number = 5) {
    return of(true).pipe(
        map(() => new Proxy().fetch('/export/getStatus', { exportId })),
        switchMap(identity),
        map(x =>{
            if (x === 'completed') {
                return x
            }
            throw new Error('Export not complete')
        }),
        retryWhen(errors =>
                errors.pipe(
                    scan(errorCount => {
                        if (errorCount >= maxRetry) {
                            throw new Error('Export not completed after 5 tries')
                        }

                        return errorCount + 1
                    }, 0),
                    delay(500),
                ),
            ),
        map(() => exportId)
    )
}

function getExport(exportId: string) {
    return new Proxy().fetch('/export/getExport', { exportId }, 'GET', undefined, false, false, true).pipe(
        map(stream => new Blob([stream], {type: 'application/pdf'}))
    )
}

export function exportItem(itemId: string, language: string, printableReportId: string, shouldBeRotated: boolean) {
    return startExport(itemId, language, printableReportId, shouldBeRotated).pipe(
        switchMap((exportId) => {
            return repeatedlyCheckExportStatus(exportId, 10)
        }),
        switchMap(getExport)
    )
}